import { render } from "./app-logo.vue?vue&type=template&id=452262ae"
import script from "./app-logo.vue?vue&type=script&lang=js"
export * from "./app-logo.vue?vue&type=script&lang=js"

import "./app-logo.vue?vue&type=style&index=0&id=452262ae&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__